// The browser-tab icon: the owner's own (website editor -> Design); on Ownezzy's demo stores, Ownezzy's; otherwise
// the store type's emoji drawn as a small picture, so a seller's tab never shows Ownezzy's icon.
const emojiIcon = (emoji) =>
    `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="88">${emoji}</text></svg>`)}`;

export function applyFavicon(config, type) {
    const href =
        config.favicon ||
        (config.showOwnezzyOffer ? (config.ownezzyBranding && config.ownezzyBranding.favicon) || "/ownezzy/favicon-32.png" : emojiIcon(type.icon));
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = href;
}
